import React, { memo } from 'react'
import { CERTIFICATION_CODE_LABELS } from 'transfix-form/forms/CarrierCertifications/components/CertificationModal/constants'
import EditIcon from 'transfix-icons/build/EditIcon'
import { IconButton, TIconButtonProps } from 'transfix-ui/components/IconButton'
import Tag, { TAG_SIZE, TAG_STYLE } from 'transfix-ui/components/Tag'
import { makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { formatDate } from 'utils/formatDatetime'
import { ICarrierProfileCertificationFragment } from '../graphql/CarrierProfileCertificationFragment'

const useCarrierDiverseCertificationsCardRowStyles = makeStyles(theme => ({
  iconWrapper: {
    color: brandColors.skyBlue6,
    marginLeft: theme.spacing(1),
  },
  certificationRow: {
    borderTop: `1px solid ${brandColors.coolGray2}`,
    padding: `${theme.spacing(2)} 0`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  certificationContent: {
    marginRight: theme.spacing(2),
  },
}))

export interface ICarrierDiverseCertificationsCardRowProps {
  certification: ICarrierProfileCertificationFragment
  onClick: TIconButtonProps['onClick']
}

export const CarrierDiverseCertificationsCardRow = memo<ICarrierDiverseCertificationsCardRowProps>(
  ({ certification, onClick }) => {
    const { code, isVerified, issuingOrganization, renewalDate } = certification
    const codeLabel = CERTIFICATION_CODE_LABELS[code]
    const classes = useCarrierDiverseCertificationsCardRowStyles()

    return (
      <div className={classes.certificationRow}>
        <div className={classes.certificationContent}>
          <Typography component='div' variant='subtitle1'>
            {codeLabel}
          </Typography>
          <Typography component='div' variant='body2'>
            {issuingOrganization && <span>{issuingOrganization}</span>}
            {issuingOrganization && renewalDate && <span> - </span>}
            {renewalDate && <span>Renews {formatDate(renewalDate, 'monthDateFormat')}</span>}
          </Typography>
        </div>
        <div>
          {isVerified && (
            <Tag label='Verified' tagStyle={TAG_STYLE.success} size={TAG_SIZE.xsmall} />
          )}
          {!isVerified && (
            <div className={classes.iconWrapper}>
              <IconButton Icon={EditIcon} onClick={onClick} size='large' />
            </div>
          )}
        </div>
      </div>
    )
  }
)

export default CarrierDiverseCertificationsCardRow
